<template>
    <div :id="this.id" class="modal">
        <!-- Modal content -->
        <div class="modal-content">
            <span class="close">&times;</span>
            <input class="form-control" type="text" id="createModal_delivery_note_number" :placeholder="$t('page.management.avis.delivery_note_number')"/>

            <select class="form-control" id="createModal_supplier" name="supplier">
                <option value="" disabled selected>{{ $t('page.management.avis.choose_supplier') }}</option>
                <option v-for="supplier in this.suppliers" :value="supplier.id">{{supplier.name}}</option>
            </select>
            <date-picker id="createModal_datepicker" value="this.date" v-bind:config = "{locale: 'de', showTodayButton: true, useCurrent: true}"></date-picker>
            <avis-item-append :placeholder="placeholder"
                              :url="url"
                              name="product_sku[]"></avis-item-append>
            <button type="button" id="avis_create_btn" class="form-control">{{ $t('page.product.view.create')}}</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AvisModal",
        props: {
            id: String,
            date: String,
            placeholder: String,
            url: String,
            suppliers: Array,
        },
        data: function() {
            return {
                suppliersArray: [],
            }
        },
        bind: {
            items: [],

        },
        mounted() {
            //this.suppliersArray = JSON.parse(this.suppliers);
        },

        methods: {

        }
    }

</script>
